<template>
  <div class="viewport-wrapper filtered">      
   <div class="izbl-part mb-2" v-for="item in list" :key="item.id">
     <div class="card">
       <div class="card-header">{{item.title}}</div>
       <div class="card-body">
        <div v-for="filteredContent in item.children" :key="filteredContent.id">
          <ByLawContentRefined :content="filteredContent" />
        </div>
       </div>
     </div>
      
   </div>
  </div>
</template>


<script>
import  "@/assets/sass/documentviewer.scss";
import ByLawContentRefined from '@/components/RefinedContent.vue';
export default {
  name: "FilterResult",
  components: {
    ByLawContentRefined
  },
  props: {
    list: Array
  },
  data() {
    return {
     
    };
  },  
  computed: {
    
  },
  mounted() {
   
  },
  methods: {
    
  },
  watch: {
    
  }
};
</script>
